import React from "react";

const Resize2Icon = ({ viewBox = "0 0 24 24", className = "hayley-h-6 hayley-w-6 hayley-text-inherit" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} fill="none" className={className}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M20 4l-6.621 6.62M10.62 13.38L4 20M20 10.62h-6.62V4M11.173 19.448v-6.62h-6.62"
      ></path>
    </svg>
  );
};

export default Resize2Icon;
